import { Injectable } from '@angular/core';
import { type Observable, shareReplay } from 'rxjs';
import { map } from 'rxjs/operators';

import type { MemberAreaUser } from '@common/types/user.type';
import { type EduUser, type LandingPageUser } from '@common/types/user.type';
import { type HttpDataResponse } from '@common/types/http-response.type';

import { BaseHttpService } from '@common/services/REST/base.http.service';

@Injectable({
    providedIn: 'root',
})
export class UserHttpService extends BaseHttpService {
    public getUser(): Observable<LandingPageUser> {
        return this.http.get<HttpDataResponse<LandingPageUser>>(this.formatApiUrl('user-tariff')).pipe(
            shareReplay(),
            map((res: HttpDataResponse<LandingPageUser>) => res.data)
        );
    }

    public getEduUser(): Observable<EduUser> {
        return this.http.get<HttpDataResponse<EduUser>>(this.formatEduServiceApiUrl(`user-tariff`)).pipe(
            shareReplay(),
            map((res: HttpDataResponse<EduUser>) => res.data)
        );
    }

    public getMemberAreaUser(): Observable<MemberAreaUser> {
        return this.http.get<HttpDataResponse<MemberAreaUser>>(this.formatApiUrl('user')).pipe(
            shareReplay(),
            map((res: HttpDataResponse<MemberAreaUser>) => res.data)
        );
    }
}
